import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { errorMessages, successMessages } from 'data/messages/messages';
import { TRtkErrorType } from 'data/types/general.types';
import Modal from 'components/Base/Modal';
import { EProjectCustomTools } from 'shared/types/generic.types';
import { useCreateCustomToolMutation } from 'redux/apiSlices/customTool.slice';
import AddCustomToolForm from './AddCustomToolForm';
import { AddCustomToolSchema } from '../../../../../../../data/validation/ToolsSchema';

const AddCustomToolModal: FC<{
  open: boolean;
  closeModal: () => void;
  projectId: string;
  customToolType: EProjectCustomTools;
}> = ({ open, closeModal, projectId, customToolType }) => {
  const [createCustomTool, { isLoading }] = useCreateCustomToolMutation();
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, formState, register } = useForm<{
    link: string;
    name: string;
  }>({
    defaultValues: {
      link: '',
      name: '',
    },
    resolver: yupResolver(AddCustomToolSchema),
  });

  const onClose = () => {
    closeModal();
  };

  const onSubmit: SubmitHandler<{
    link: string;
    name: string;
  }> = async values => {
    try {
      await createCustomTool({
        projectId,
        name: values.name,
        link: values.link,
        type: customToolType,
      }).unwrap();
      enqueueSnackbar(successMessages.toast, {
        variant: 'success',
      });
      closeModal();
    } catch (err) {
      const error = err as TRtkErrorType;
      enqueueSnackbar(error?.data?.message || errorMessages.default, {
        variant: 'error',
      });
    }
  };
  return (
    <Modal
      open={open}
      handleClose={onClose}
      title={customToolType}
      submitButtonProps={{
        disabled: formState.isSubmitting,
        loading: isLoading,
        text: 'Create',
        onClick: handleSubmit(onSubmit),
      }}
      contentProps={{ sx: { minWidth: '300px' } }}
    >
      <AddCustomToolForm
        onSubmit={handleSubmit(onSubmit)}
        formState={formState}
        register={register}
      />
    </Modal>
  );
};

export default AddCustomToolModal;
